import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { StatusBadge } from '@/components/admin/StatusBadge';

const ApplicationDetailModal = ({ entry, onClose }) => {
  if (!entry) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
        onClick={onClose}
        data-testid="application-detail-modal"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="bg-white border-2 border-[#0F1B2D] w-full max-w-lg max-h-[85vh] overflow-y-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="bg-[#0F1B2D] px-6 py-4 flex items-center justify-between">
            <div>
              <h3 className="font-['Playfair_Display'] text-lg font-semibold text-[#F5F3EE]">{entry.name}</h3>
              <span className="text-[11px] font-mono text-[#C4A35A]">{entry.application_id || '—'}</span>
            </div>
            <button onClick={onClose} className="text-[#9B9589] hover:text-white transition-colors" data-testid="close-app-modal"><X size={18} /></button>
          </div>
          <div className="p-6 space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Email</p><p className="text-sm text-[#0F1B2D]">{entry.email}</p></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Phone</p><p className="text-sm text-[#0F1B2D]">{entry.phone || '—'}</p></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Profession</p><p className="text-sm text-[#0F1B2D]">{entry.profession}</p></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">PAN</p><p className="text-sm font-mono text-[#0F1B2D]">{entry.pan || '—'}</p></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Experience</p><p className="text-sm text-[#0F1B2D]">{entry.experience_years != null ? `${entry.experience_years} years` : '—'}</p></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Country</p><p className="text-sm text-[#0F1B2D]">{entry.country || '—'}</p></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Status</p><StatusBadge status={entry.status || 'verification_pending'} /></div>
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">Applied</p><p className="text-sm text-[#0F1B2D]">{new Date(entry.created_at).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p></div>
            </div>
            {entry.imdb_link && (
              <div><p className="text-[9px] text-[#9B9589] font-bold uppercase">IMDB</p><a href={entry.imdb_link} target="_blank" rel="noreferrer" className="text-sm text-blue-600 hover:underline">{entry.imdb_link}</a></div>
            )}
            {entry.remarks && (
              <div className="bg-red-50 border border-red-200 p-3"><p className="text-[9px] text-red-600 font-bold uppercase mb-1">Remarks</p><p className="text-xs text-red-700">{entry.remarks}</p></div>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ApplicationDetailModal;
